<template>
  <div
    class="action-item f-w"
    :class="actionItemClass"
    @click="actionClick()"
  >
    <div v-if="pending && !noDragHandle" class="drag-handle">
      <img class="f-w f-h" src="/images/drag.png" alt="">
    </div>
    <div
      v-if="pending && value.isSupport == 1"
      v-quick-title="$t('message.ACTION_FROM_OTHER_TEAM')"
      class="a-from-support h-v-centerer"
    >
      <div class="triangle" />
      <Icon>{{ receivedExtraBold }}</Icon>
    </div>
    <table class="f-w">
      <td v-if="!pending && !isSecuring" class="action-item__td pdca-td">
        <Pdca
          v-model="value.pdca"
          :pdca-id="value.id"
          :disabled="!isPDCAEditable || !isStatusEditable"
          @input="$emit('pdcaChange')"
        />
      </td>
      <td class="action-item__td action-item-basics">
        <EditableLabel
          :key="titleKey"
          v-model="value.name"
          class="action-item__title"
          ellipsize
          :disabled="pending || disabled"
          :placeholder="pending ? '' : $t('message.DESCRIPTION_PH')"
          @input="edit('name')"
          @startEdit="titleStartEdit"
        />
        <div
          v-if="pending"
          class="v-centerer"
          style="height: 1.5em;"
        >
          <span class="legend">{{ $t('message.IMPACT') + $t('message.TWO_DOTS') }}</span>
          <span style="display: none">
            <VueSlider
              ref="pendingSlider"
              v-model="value.impact"
              v-bind="sliderProperties"
              style="padding:5px;margin-left:10px;display: inline-block;"
            />
          </span>
          <span class="legend" style="margin-left:10px">{{ value.impact }}</span>
        </div>
        <EditableLabelRadio
          v-model="leaderValue"
          class="action-item__leader"
          :items="radioUsers"
          label-key="label"
          id-key="radioId"
          :placeholder="leaderPlaceholder"
          :disabled="disabled || pending"
          ellipsize
          @click="disabled ? actionClick() : ''"
        />
        <div v-if="pending && tiptapTasks !== ''" class="v-centerer tiptap-tasks">
          <Icon remix-icon="checkbox-line" />
          <span>{{ tiptapTasks }}</span>
        </div>
        <Icon v-if="pending && isSecuring" class="securing-action" :class="securingIconClass(null, value)">
          {{ securing }}
        </Icon>
        <div v-if="!pending" :style="statusStyle">
          <div v-if="isSecuring" class="v-centerer">
            <Icon class="securing-action" :class="securingIconClass(null, value)">{{ securing }}</Icon>
            <EditableLabelRadio
              v-model="value.state"
              class="securing-state"
              :items="secuStates"
              label-key="title"
              @input="edit('state')"
            />
          </div>
          <div v-else>
            ● {{ statusTitle }}
          </div>
        </div>
        <div v-if="!pending && !isSecuring" class="expand" @click.stop="expand">
          <img src="/images/expand.png" alt="Expand" :style="expanded ? 'transform: rotate(180deg);' : ''">
        </div>
      </td>
      <td v-if="pending || !isSecuring" class="action-item__td deadline">
        <div class="deadline-legend">
          {{ $t('message.DEADLINE') }}
        </div>
        <VisualCalendar v-model="value.deadline" :disabled="disabled || pending" @input="deadlineEdit" />
      </td>

      <img
        v-if="!pending"
        class="delete-btn"
        src="/images/delete.png"
        alt=""
        @click="deleteClick"
      >
    </table>
    <div v-if="pending && value.problem != 0">
      <div class="sep" />
      <table>
        <td class="action-item__td">
          <EditableLabel
            v-model="value.lWhat"
            :legend="$t('message.PROBLEM') + $t('message.TWO_DOTS')"
            :disabled="true"
          />
          <EditableLabel
            v-model="value.causeText"
            :legend="$t('message.CAUSE') + $t('message.TWO_DOTS')"
            :disabled="true"
          />
          <button class="see-sheet add-button reverse" @click.stop="$emit('sheetClick')">
            {{ $t('message.PROBLEM_SHEET') }}<img src="/images/see.png" alt="">
          </button>
        </td>
        <td class="action-item__td action-item-pbimg">
          <img :src="fUtilsFirstPictureData" alt="">
        </td>
      </table>
    </div>
    <!-- Details section displayed in a problem sheets -->
    <div v-if="!pending && !isSecuring" v-show="expanded" class="expanded-content">
      <EditableLabelRadio
        v-model="value.cause"
        :legend="$t('message.CAUSE') + $t('message.TWO_DOTS')"
        :items="causeItems"
        label-key="text"
        :disabled="disabled"
        @input="edit('cause')"
      />
      <div class="v-centerer slider-wrapper">
        <span class="legend">{{ $t('message.IMPACT') + $t('message.TWO_DOTS') }}</span>
        <span style="display:inline-flex">
          <VueSlider
            ref="slider"
            v-model="value.impact"
            v-bind="sliderProperties"
            :disabled="disabled"
            style="padding:5px;margin-left:10px;display: inline-block;"
            @click.native="edit('impact')"
            @drag-end="edit('impact')"
          />
        </span>
        <span class="legend" style="margin-left:10px">{{ value.impact }}</span>
      </div>
      <div v-if="currentTeam.displayActionGain" class="gain-wrapper">
        <div v-if="value.gain != ''">
          <EditableLabel
            class="inline"
            :legend="$t('message.GAIN') + $t('message.TWO_DOTS')"
            :value="value.gain"
            :disabled="disabled"
            @input="filterGainValue"
          />
          <EditableLabel
            v-model="value.gainUnit"
            class="inline gain-unit"
            :legend="$t('message.UNIT') + $t('message.TWO_DOTS')"
            :disabled="disabled"
            @input="edit('gainUnit')"
          />
        </div>
        <div v-else>
          <button class="add-button gain-btn" @click="defineGain">
            <img src="/images/gain.png" alt="Gain">
            {{ $t('message.DEFINE_GAIN') }}
          </button>
        </div>
      </div>
      <EditableLabel
        v-model="value.comment"
        :legend="$t('message.COMMENTS') + $t('message.TWO_DOTS')"
        :placeholder="$t('message.COMMENT_PLACEHOLDER')"
        :disabled="disabled"
        use-tiptap-editor
        display-tiptap-menu
        display-tiptap-tasks
        @input="edit('comment')"
      />
      <div v-if="value.state != 2" class="plans-wrapper">
        <EditableLabelRadio
          v-model="value.plan"
          :legend="$t('message.ACTION_PLAN') + $t('message.TWO_DOTS')"
          :items="allPlans"
          label-key="name"
          :disabled="!isStatusEditable"
          @input="assignAction"
        />
      </div>
      <div v-else>
        <em><b>{{ $t('message.ACTION_COMPLETED') }}</b></em>
      </div>
      <button class="option-button" @click="displayActionInModal">
        {{ $t('message.ACTION_SHEET') }}
      </button>
      <!-- Team picker when sending an action to a support plan -->
      <AdvancedTeamPicker
        v-if="selectingSupportTeams"
        :value="[]"
        display-all-teams
        invisible
        ok-button
        single-value
        edit-mode-always-on
        @input="suppTeamClicked"
      />
    </div>
  </div>
</template>

<script>
/**
 * Item in an actions list
 *
 * @vue-prop {Object} value - action item data
 * @vue-prop {Boolean} pending - Action is pending or not
 * @vue-prop {Boolean} disabled - Allow or not action modifications
 * @vue-prop {Array} [allPlans=[]] - Array of action plans
 * @vue-prop {Array} [allCauses=[]] - Array of causes
 * @vue-prop {Boolean} noDragHandle - Allow drag element or not
 * @vue-prop {Number} [problemAffectTeam=0] - Id of the affected team to this action
 * @vue-prop {Array} assignableTeams - IDs of the teams that may be assigned this action
 */

import $ from 'jquery';
import { cloneDeep, uniq } from 'lodash';
import toastr from 'toastr';
import VueSlider from 'vue-slider-component';
// Vuex utils
import { mapState } from 'vuex';
import { ASSIGN_ACTION } from '@/store/action-types';
import { GET_TEAMS } from '@/store/mutation-types';
// Components
import AdvancedTeamPicker from '@/components/advanced-team-picker.vue';
import EditableLabel from '@/components/editable-label.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import Icon from '@/components/icon.vue';
import Pdca from '@/components/pdca.vue';
import VisualCalendar from '@/components/visual-calendar.vue';
// Mixins
import mixinFileUtils from '@/mixins/file-utils.vue';
import mixinSocketHandler from '@/mixins/socket-handler.vue';
// Utils
import { receivedExtraBold, securing } from '@/assets/icons';
import { decodeHTML, noTooltipSliderProperties } from '@/utils/main';
import { getTasksFromTiptapContent } from '@/plugins/tiptap';
import { securingIconClass } from '@/utils/problem-utils';

export default {

  name: 'ActionItem',

  components: {
    AdvancedTeamPicker,
    EditableLabel,
    EditableLabelRadio,
    Icon,
    Pdca,
    VisualCalendar,
    VueSlider,
  },

  mixins: [mixinSocketHandler, mixinFileUtils],

  props: {
    value: {
      type: Object,
      required: true,
    },
    pending: Boolean,
    disabled: Boolean,
    allPlans: {
      type: Array,
      default: () => [],
    },
    allCauses: {
      type: Array,
      default: () => [],
    },
    noDragHandle: Boolean,
    problemAffectTeam: {
      type: Number,
      default: 0,
    },
    assignableTeams: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      receivedExtraBold,
      securing,
      states: [
        { title: this.$t('message.ACTION_STATE_PENDING'), color: '#8B8C8F', tileColor: '#FFFFFF' },
        { title: this.$t('message.ACTION_STATE_ONGOING'), color: '#00ADEE', tileColor: '#FFFFFF' },
        { title: this.$t('message.ACTION_STATE_COMPLETED'), color: '#048E2B', tileColor: '#EFEFEF' },
      ],
      secuStates: [
        { id: 0, title: this.$t('message.ACTION_STATE_PENDING'), color: '#8B8C8F' },
        { id: 1, title: this.$t('message.ACTION_STATE_ONGOING'), color: '#F05A28' },
        { id: 2, title: this.$t('message.ACTION_STATE_COMPLETED'), color: '#048E2B' },
      ],
      expanded: false,
      fromPlan: 0,
      isEditingName: false,
      titleKey: 1,
      selectingSupportTeams: false,
    };
  },

  computed: {
    isPDCAEditable() {
      // If not in support plan and isn't on the parking lot (state 0) or archived (state 2), PDCA is editable
      return ((this.value.supportPlan === null || this.value.supportPlan === undefined)
        && Number(this.value.state) === 1);
    },
    actionItemClass() {
      return {
        pending: this.pending,
        'in-sheet': !this.pending,
        'action-item--on-going-securing': this.isSecuring && !this.pending,
      };
    },
    sliderProperties() {
      const props = cloneDeep(noTooltipSliderProperties);
      props.width = '80px';
      if (this.pending) {
        props.disabled = true;
      }
      return props;
    },
    /** Selected plan */
    currentPlan() {
      for (let i = 0, len = this.allPlans.length; i < len; i++) {
        if (Number(this.allPlans[i].id) === Number(this.value.plan)) {
          return this.allPlans[i];
        }
      }
      return null;
    },
    /** Cause items to choose from */
    causeItems() {
      const causes = cloneDeep(this.allCauses);
      causes.unshift({ id: 0, text: this.$t('message.NO_CAUSE') });
      return causes;
    },
    statusTitle() {
      return this.states[this.status || 0].title;
    },
    statusStyle() {
      return this.isSecuring
        ? `color: ${this.secuStates[this.value.state].color}`
        : `color: ${this.states[this.status || 0].color}`;
    },
    status() {
      if (this.value.pdca === 4) {
        return 2;
      }
      if (this.value.plan === 0) {
        return 0;
      }
      return 1;
    },
    /** Placeholder when no leader selected */
    leaderPlaceholder() {
      return this.pending && !this.value.teamName
        ? this.$t('message.NO_LEADER')
        : this.$t('message.AFFECT_TEAM_NO_LEADER', { team: decodeHTML(this.value.teamName || this.currentTeam.name) });
    },
    /** Whether the current team is the team in charge of this action */
    isStatusEditable() {
      return !this.value.affectTeam
        || this.currentTeam.id === this.value.affectTeam
        || this.currentTeam.id === this.problemAffectTeam;
    },
    /** Value is a securing action */
    isSecuring() {
      return this.value.isSecuring === 1;
    },
    fUtilsFileIds() {
      return this.value.problemFiles;
    },
    /**
     * Array of teams selectable in EditableLabelRadio :
     * As of v1.6.0, multiple teams may contain the same user (same ID)
     * So the item in the EditableLabelRadio must be identified by the user ID AND the team ID
     * @return {Array} Updated array with 'radioId' property equal to '<teamId>-<userId>'
     */
    radioUsers() {
      // Filter teams to show only assignable teams
      const assignable = uniq([...this.assignableTeams, this.value.affectTeam]);
      const filteredTeams = cloneDeep(this.teams.filter(team => assignable.includes(team.id)));
      // Parse for EditableLabelRadio
      return filteredTeams.map(team => ({
        ...team,
        title: team.name,
        radioItems: team.users.map(user => ({ ...user, radioId: `${team.id}-${user.id}` })),
      }));
    },
    /** String: Value to use for the leader EditableLabelRadio */
    leaderValue: {
      get() {
        return `${this.value.affectTeam}-${this.value.leader}`;
      },
      set(leaderTeam) {
        const [team, leader] = leaderTeam.split('-');
        if (team && leader) {
          this.value.leader = Number(leader);
          this.value.affectTeam = Number(team);
          this.edit(['affectTeam', 'leader']);
        }
      },
    },
    /** String: Display the number of tasks added to the 'comment' field */
    tiptapTasks() {
      const tasks = getTasksFromTiptapContent(this.value.comment || '');
      return tasks ? `${tasks.n} / ${tasks.total}` : '';
    },
    ...mapState({
      teams: state => state[GET_TEAMS.stateKey] || [],
    }),
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal.plan !== oldVal.plan) {
          this.fromPlan = newVal.plan;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.fromPlan = this.value.plan;
    $(window).on(`resizeEnd.${this.uuid}`, () => {
      // Prevent any reset while the field is being edited
      if (this.isEditingName) {
        return;
      }
      // Reset the title EditableLabel to update the ellipsis
      this.titleKey++;
    });
  },

  methods: {
    securingIconClass,
    edit(field) {
      if (field === 'name') {
        this.isEditingName = false;
        this.titleKey++;
      }
      this.$emit('fieldInput', field);
    },
    actionClick() {
      this.$emit('actionClick');
    },
    expand() {
      this.expanded = !this.expanded;
    },
    defineGain() {
      if (this.disabled) {
        return;
      }
      if (this.value.gain === '') {
        this.value.gain = '0';
        this.$set(this.value, 'gainUnit', this.$t('message.GAIN_UNIT_DEFAULT'));
      }
    },
    filterGainValue(gainValue) {
      const number = parseFloat(gainValue);
      // Set to 0 if not number or negative
      this.value.gain = (Number.isNaN(number) || number < 0 ? '0' : number.toString());
      this.edit('gain');
    },
    deadlineEdit(val) {
      this.value.deadline = `${val} 00:00:00`;
      this.edit('deadline');
    },
    deleteClick() {
      if (!this.disabled) {
        this.$emit('deleteClick');
      }
    },
    /** Asign the ation to a plan */
    assignAction() {
      if (this.disabled) {
        this.value.plan = this.fromPlan;
        return;
      }
      const currentPlan = this.allPlans.find(plan => plan.id === this.value.plan);
      if (this.value.id && currentPlan) {
        // Support action plan => assign to another team
        if (this.currentPlan.support === 1) {
          this.selectingSupportTeams = true;
          return;
        }
        this.$store.dispatch(ASSIGN_ACTION, { action: this.value, fromPlanId: this.fromPlan })
          .then((data) => {
            this.$emit('updatePlans');
            this.fromPlan = this.value.plan;
            this.value.state = data.state;
            this.value.deadline = data.deadline;
            this.value.pdca = data.pdca;
          })
          .catch(() => {
            this.value.plan = this.fromPlan;
          });
      } else {
        toastr.info(this.$t('message.SAVE_BEFORE_ASSIGN'));
      }
    },
    /** Send request to assign the action to the selected team */
    suppTeamClicked(teams) {
      if (teams == null || teams.length === 0) {
        return;
      }
      this.selectingSupportTeams = false;
      this.$store.dispatch(ASSIGN_ACTION, { action: this.value, fromPlanId: this.fromPlan, supportTeamId: teams[0] })
        .then((data) => {
          this.$emit('updatePlans');
          this.fromPlan = this.value.plan;
          this.value.state = data.state;
          this.value.deadline = data.deadline;
          this.value.pdca = data.pdca;
          this.value.plan = data.plan;
          this.value.affectTeam = data.affectTeam;
          this.value.teamName = data.teamName;
          this.value.leader = 0;
        })
        .catch(() => {
          this.value.plan = this.fromPlan;
        });
    },
    /** Display the modal who contain the action */
    displayActionInModal() {
      this.$router.push(this.getActionCreationLink(this.value.id));
    },
    /** Detect edition start on the title field */
    titleStartEdit() {
      this.isEditingName = true;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.action-item {
  position: relative;
  background: #fff;
  padding: 7px 14px;
  box-sizing: border-box;
  border: 1px solid $color-gray-border;

  &--on-going-securing {
    border-radius: $medium-border-radius;
    margin-bottom: 15px;
    padding: 10px !important;
    width: $action-item-width;
    cursor: pointer;
  }

  & > .expanded-content {
    .editable-label-text {
      white-space: pre-line;
    }
  }

  &.in-sheet {
    padding: 4px 8px;

     .slider-wrapper {
        margin: 1px 0px;
        padding: 0px;

      &.gain-unit {
        margin-left: 10px;
      }
    }
    .securing-action {
      left: 20px;
      top: 65px;
    }
  }
  .gain-btn {
    padding: 1px 0px;

    img {
      width: 18px;
      margin-right: 6px;
    }
  }
  &.pending .deadline-legend {
    font-size: 0.85em;
    margin-top: -3px;
  }
  .securing-action {
    width: 1.3em;
    height: auto;
    margin-right: 5px;
  }
  &.pending .securing-action {
    position: absolute;
    left: 10px;
    top: 37px;
  }
  .see-sheet {
    padding: 1px 5px;
    margin-left: -5px;

    &:hover {
      background-color: $color-hoverbtn-light-blue;
    }
  }
  &__td {
    padding: 0px;
    width: 100%;
    vertical-align: top;
  }

  &__title {
    margin-bottom: 0.3rem;

    .editable-label-text {
      line-height: 1.4em;
      max-height: 4.2em;
      font-weight: 600;
    }

    div.textarea {
      max-height: unset;
    }
  }

  &__leader {
    margin-bottom: 0.4rem;
  }
}

.action-item:not(:first-child) {
  margin-top: 10px;
}
.action-item table {
  border-collapse: collapse;
  table-layout: fixed;
}
.action-item .pdca-td {
  width: 55px;
}
.action-item .deadline {
  text-align: center;
  width: 70px;

  .visual-calendar {
    margin-bottom: 3px;
  }
}
.action-item .expand {
  text-align: center;
  cursor: pointer;
}
.action-item .expand img {
  height: 11px;
  display: block;
  margin: auto;
  padding: 5px;
}
.action-item .action-item-pbimg { width: 70px; }
.action-item .action-item-pbimg img {
  width: 60px;
  height: 60px;
  object-fit: cover;
}
.action-item .sep {
  width: 80%;
  margin: 5px 10% 10px 10%;
}
.action-item .delete-btn {
  position: absolute;
  right: 0px;
  bottom: 0px;
  padding: 5px;
  width: 20px;
  cursor: pointer;

  &:hover {
    background: $color-hoverbtn-red;
  }
}
.action-item .pdca {
  padding: 10px 10px 0 0;
}
.action-item .pdca canvas {
  width: 45px !important;
  height: 45px !important;
}

@media (max-width: $smartphone-landscape) {
  .action-item {
    padding: 3px;

    &--on-going-securing {
      max-width: initial;
      min-width: initial;
    }

    &.pending .securing-action {
      left: 5px;
      top: 35px;
    }
    .pdca canvas {
      width: 30px !important;
      height: 30px !important;
    }
    .pdca-td, .pdca {
      width: 35px;
      padding: 0px;
    }
    .deadline {
      width: 50px;
    }
    .sep {
      width: 80%;
      margin: 5px 10% 10px 10%;
    }
  }
}

@media (max-width: $smartphone-portrait) {
  .action-item {
    &.in-sheet .deadline-legend {
      display: none;
    }
  }
}
</style>
